import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxInputStarRatingModule } from '@ngx-lite/input-star-rating';
import { NouisliderModule } from 'ng2-nouislider';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ExportAsModule } from 'ngx-export-as';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxLoadingModule } from 'ngx-loading';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { RangeSliderModule } from '../range-slider/range-slider.module';
import {
    HotelCancellationComponent, HotelResultsComponent, HotelSearchComponent,
    HotelVoucherComponent
} from './components';
import { AmenityInfoComponent } from './components/hotel-booking/components/amenity-info/amenity-info.component';
import { CancelInfoComponent } from './components/hotel-booking/components/cancel-info/cancel-info.component';
import { HotelConfirmationComponent } from './components/hotel-booking/components/hotel-confirmation/hotel-confirmation.component';
import { HotelDetailImagesComponent } from './components/hotel-booking/components/hotel-detail-images/hotel-detail-images.component';
import { HotelDetailComponent } from './components/hotel-booking/components/hotel-detail/hotel-detail.component';
import { HotelGuestDetailsComponent } from './components/hotel-booking/components/hotel-guest-details/hotel-guest-details.component';
import { HotelPaymentConfirmationComponent } from './components/hotel-booking/components/hotel-payment-confirmation/hotel-payment-confirmation.component';
import { HotelPaymentDetailComponent } from './components/hotel-booking/components/hotel-payment-detail/hotel-payment-detail.component';
import { HotelCustomerReviewsComponent } from './components/hotel-booking/components/hotel-room-detail/components/hotel-customer-reviews/hotel-customer-reviews.component';
import { HotelRoomModifyComponent } from './components/hotel-booking/components/hotel-room-detail/components/hotel-room-modify/hotel-room-modify.component';
import { HotelRoomDetailComponent } from './components/hotel-booking/components/hotel-room-detail/hotel-room-detail.component';
import { LowBalanceAlertComponent } from './components/hotel-booking/components/low-balance-alert/low-balance-alert.component';
import { SimilarHotelsComponent } from './components/hotel-booking/components/similar-hotels/similar-hotels.component';
import { HotelBookingComponent } from './components/hotel-booking/hotel-booking.component';
import { AmenitiesFilterComponent } from './components/hotel-results/components/filter-hotels/amenities-filter/amenities-filter.component';
import { FilterHotelsComponent } from './components/hotel-results/components/filter-hotels/filter-hotels.component';
import { HotelAccomodationFilterComponent } from './components/hotel-results/components/filter-hotels/hotel-accomodation-filter/hotel-accomodation-filter.component';
import { HotelNamesearchFilterComponent } from './components/hotel-results/components/filter-hotels/hotel-namesearch-filter/hotel-namesearch-filter.component';
import { HotelPriceFilterComponent } from './components/hotel-results/components/filter-hotels/hotel-price-filter/hotel-price-filter.component';
import { RatingFilterComponent } from './components/hotel-results/components/filter-hotels/rating-filter/rating-filter.component';
import { HotelSearchLoaderComponent } from './components/hotel-results/components/hotel-search-loader/hotel-search-loader.component';
import { SortingHotelsComponent } from './components/hotel-results/components/sorting-hotels/sorting-hotels.component';
import { HotelModifySearchComponent } from './components/hotel-results/hotel-modify-search/hotel-modify-search.component';
import { HotelSearchFormComponent } from './components/hotel-search/components/hotel-search-form/hotel-search-form.component';
import { HotelRoutingModule } from './hotel-routing.module';
import { HotelComponent } from './hotel.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NearByFilterComponent } from './components/hotel-results/components/filter-hotels/near-by-filter/near-by-filter.component';
import { FreeCancelFilterComponent } from './components/hotel-results/components/filter-hotels/free-cancel-filter/free-cancel-filter.component';
import { InterestFilterComponent } from './components/hotel-results/components/filter-hotels/interest-filter/interest-filter.component';
import { MealPlanFilterComponent } from './components/hotel-results/components/filter-hotels/meal-plan-filter/meal-plan-filter.component';
import { ConfirmationModelComponent } from './components/hotel-booking/components/hotel-room-detail/components/confirmation-model/confirmation-model.component';
import { HotelPaymentStatusComponent } from './components/hotel-booking/components/hotel-payment-detail/hotel-payment-status/hotel-payment-status.component';

@NgModule({
    declarations: [
        HotelComponent,
        HotelResultsComponent,
        HotelVoucherComponent,
        HotelSearchComponent,
        HotelCancellationComponent,
        HotelSearchFormComponent,
        SortingHotelsComponent,
        FilterHotelsComponent,
        AmenitiesFilterComponent,
        HotelAccomodationFilterComponent,
        HotelNamesearchFilterComponent,
        HotelPriceFilterComponent,
        RatingFilterComponent,
        HotelBookingComponent,
        CancelInfoComponent,
        HotelConfirmationComponent,
        HotelDetailComponent,
        HotelDetailImagesComponent,
        HotelGuestDetailsComponent,
        HotelPaymentConfirmationComponent,
        HotelPaymentDetailComponent,
        HotelRoomDetailComponent,
        LowBalanceAlertComponent,
        SimilarHotelsComponent,
        HotelModifySearchComponent,
        HotelRoomModifyComponent,
        AmenityInfoComponent,
        HotelCustomerReviewsComponent,
        HotelSearchLoaderComponent,
        NearByFilterComponent,
        FreeCancelFilterComponent,
        InterestFilterComponent,
        MealPlanFilterComponent,
        ConfirmationModelComponent,
        HotelPaymentStatusComponent
    ],
    imports: [
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        NouisliderModule,
        BsDatepickerModule.forRoot(),
        RatingModule.forRoot(),
        CollapseModule.forRoot(),
        InfiniteScrollModule,
        GoogleMapsModule,
        TooltipModule.forRoot(),
        NgxLoadingModule.forRoot({}),
        RangeSliderModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
        TypeaheadModule.forRoot(),
        ExportAsModule,
        NgxInputStarRatingModule,
        NgxSliderModule,
        HotelRoutingModule,
        NgbModule,
        ModalModule.forRoot(),
    ],
    providers: [DatePipe],
    exports: [
        HotelComponent,
        HotelPaymentDetailComponent,
        HotelConfirmationComponent,
        HotelPaymentConfirmationComponent,
        HotelVoucherComponent
    ],
    entryComponents: [HotelPaymentConfirmationComponent]
})
export class HotelModule { }